import React from 'react';
import { SvgIcon } from '../svg-icon';

export const FilledClose = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM16 14.5L14.5 16L12 13.41L9.5 16L8 14.5L10.59 12L8 9.5L9.5 8L12 10.59L14.5 8L16 9.5L13.41 12L16 14.5Z" />
  </SvgIcon>
);
